import { render, staticRenderFns } from "./NoteWidget.vue?vue&type=template&id=1cdc7af0&scoped=true"
import script from "./NoteWidget.vue?vue&type=script&lang=js"
export * from "./NoteWidget.vue?vue&type=script&lang=js"
import style0 from "./NoteWidget.vue?vue&type=style&index=0&id=1cdc7af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc7af0",
  null
  
)

export default component.exports